import { h, Fragment, cn, type VNode } from '../../../lib/vdom.js';

export default function About() {
  return (
    <section id="about">
      <div className="content">
        <h3 className="section-subheading">ABOUT US</h3>
        <h1 className="section-heading">Who Are We?</h1>
        <div className="body">
          <figure className="sean">
            <a href="https://www.linkedin.com/in/sean-shirazi" target="_blank">
              <img
                src="/public/shahab-sean-shirazi-small.jpg"
                alt="Shahab (Sean) Shirazi"
                width="250px"
                height="377px"
              />
            </a>
            <figcaption>
              <a href="https://www.linkedin.com/in/sean-shirazi" target="_blank" className="styled">
                <span className="name">Shahab (Sean) Shirazi</span>, Founder
              </a>
            </figcaption>
          </figure>

          <p>Our core mission is to build high-quality custom software for your business.</p>

          <p>
            Computing Den was founded in Turkey in 2022 by Shahab (Sean) Shirazi, following a decade-long career as a{' '}
            full-stack web developer.
          </p>

          <p>
            To bring your projects and visions to life, we build a small, focused team of highly experienced and
            professional programmers and designers from around the world.
          </p>

          <p>
            Our team, ensures the highest quality of code and design, as well as a robust foundational architecture to
            build upon for years. Our team is led by Sean who oversees every project, providing meticulous oversight to
            guarantee excellence. Our commitment to quality is further reinforced by rigorous automated testing
            throughout the development process.
          </p>
          <div className="clear" />
        </div>
      </div>
    </section>
  );
}
